import React, { useMemo } from 'react';
import VoiceOverPreview from '../../VoiceOverPreview';









function CustomAssetPreview({
  assetsMap,
  voiceOver,
  customThumbnail,
  thumbnailWidth,
  thumbnailHeight
}) {
  const customThumbnailAsset = useMemo(() => {
    if (!customThumbnail) {
      return;
    }
    const asset = assetsMap.get(customThumbnail);

    // eslint-disable-next-line consistent-return
    return asset;
  }, [assetsMap, customThumbnail]);

  const voiceOverAsset = useMemo(() => {
    if (!voiceOver) {
      return;
    }
    const asset = assetsMap.get(voiceOver);

    // eslint-disable-next-line consistent-return
    return asset;
  }, [assetsMap, voiceOver]);

  return (
    <div className="voice-over__list--item">
      <VoiceOverPreview
        asset={voiceOverAsset}
        customThumbnail={customThumbnailAsset}
        defaultThumbnailIconName="user"
        thumbnailWidth={thumbnailWidth}
        thumbnailHeight={thumbnailHeight} />

    </div>);

}

export default CustomAssetPreview;